import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import { Phone, Mail, MapPin, Send, Loader2, CheckCircle } from 'lucide-react';

const Contacto = () => {
  const [formData, setFormData] = useState({ fullName: '', email: '', phone: '', message: '' });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    const { error: insertError } = await supabase
      .from('contact_submissions')
      .insert({
        full_name: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        message: formData.message,
      });

    if (insertError) {
      setError('Hubo un error al enviar tu mensaje. Por favor, inténtalo de nuevo.');
      console.error('Contact form error:', insertError);
    } else {
      setSuccess(true);
      setFormData({ fullName: '', email: '', phone: '', message: '' });
    }
    setLoading(false);
  };

  return (
    <div className="bg-gray-50 py-20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Encabezado */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-extrabold text-gray-900">Ponte en Contacto</h1>
          <p className="mt-4 text-lg text-gray-600">
            Estamos listos para ayudarte a planificar tu próximo evento.
          </p>
        </div>

        {/* Contenedor */}
        <div className="grid md:grid-cols-2 gap-12 bg-white p-8 rounded-2xl shadow-xl">
          
          {/* Columna de Información */}
          <div className="flex flex-col justify-center space-y-6">
            <h2 className="text-2xl font-bold text-gray-800">Información de Contacto</h2>
            
            <div className="flex items-center">
              <Phone className="h-6 w-6 text-orange-400 mr-4" />
              <div>
                <p className="font-semibold text-gray-700">Teléfono</p>
                <a href="tel:+50379166290" className="text-gray-600 hover:text-orange-500">
                  +503 7916-6290
                </a>
              </div>
            </div>

            <div className="flex items-center">
              <Mail className="h-6 w-6 text-orange-400 mr-4" />
              <div>
                <p className="font-semibold text-gray-700">Correo Electrónico</p>
                <a href="mailto:banquetesdelchef.sv.ca@gmail.com" className="text-gray-600 hover:text-orange-500">
                  banquetesdelchef.sv.ca@gmail.com
                </a>
              </div>
            </div>

            <div className="flex items-center">
              <MapPin className="h-6 w-6 text-orange-400 mr-4" />
              <div>
                <p className="font-semibold text-gray-700">Ubicación</p>
                <p className="text-gray-600">San Salvador, El Salvador</p>
              </div>
            </div>
          </div>

          {/* Columna del Formulario */}
          <div>
            {success ? (
              <div className="flex flex-col items-center justify-center h-full bg-green-50 p-8 rounded-md text-center">
                <CheckCircle className="h-16 w-16 text-green-500 mb-4" />
                <h3 className="text-2xl font-bold text-green-800">¡Mensaje Enviado!</h3>
                <p className="text-gray-600 mt-2">
                  Gracias por contactarnos. Nos pondremos en contacto contigo a la brevedad.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  placeholder="Nombre Completo"
                  required
                  className="block w-full py-3 px-4 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:ring-orange-400 focus:border-orange-400"
                />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Correo Electrónico"
                  required
                  className="block w-full py-3 px-4 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:ring-orange-400 focus:border-orange-400"
                />
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Teléfono"
                  className="block w-full py-3 px-4 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:ring-orange-400 focus:border-orange-400"
                />
                <textarea
                  name="message"
                  rows={4}
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Escribe tu mensaje..."
                  required
                  className="block w-full py-3 px-4 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:ring-orange-400 focus:border-orange-400"
                />
                
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full flex justify-center items-center gap-3 py-3 px-6 
                             rounded-lg shadow-md text-base font-medium text-white 
                             bg-gradient-to-r from-orange-400 to-orange-500 
                             hover:from-orange-500 hover:to-orange-600 
                             focus:outline-none focus:ring-2 focus:ring-offset-2 
                             focus:ring-orange-300 disabled:opacity-50"
                >
                  {loading ? <Loader2 className="animate-spin" /> : <Send />}
                  {loading ? 'Enviando...' : 'Enviar Mensaje'}
                </button>

                {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contacto;
